package empiresmp.feature.gallery.data

import empiresmp.feature.gallery.model.GalleryItem
import empiresmp.feature.gallery.model.PagedGalleryModel
import empiresmp.feature.gallery.util.GalleryConstant
import io.ktor.client.HttpClient
import io.ktor.client.request.get
import io.ktor.client.request.parameter
import io.ktor.client.request.url
import io.ktor.client.statement.bodyAsText
import io.ktor.http.ContentType
import io.ktor.http.contentType
import kotlinx.serialization.json.Json

internal class GalleryRepository(
    private val httpClient: HttpClient,
    private val json: Json
) {

    suspend fun getGalleryItems(page: Int): PagedGalleryModel<GalleryItem> {
        val textBody = httpClient.get {
            url("${GalleryConstant.URL}/v1/gallery/galleries")
            parameter("page", page)
            contentType(ContentType.Application.Json)
        }.bodyAsText()
        return json.decodeFromString(textBody)
    }
}
